import { BIModel } from './BIModel';
export class UserReviewCompleteBIModel extends BIModel {

  static eventName = 'user_review_complete';

  #productId;
  #shippingTime;
  #descriptionQuality;
  #communication;
  #productStatus;
  #packageStatus;
  #overallRating;
  #comment;

  constructor(userId, productId, shippingTime, descriptionQuality, communication, productStatus, packageStatus, overallRating, comment) {
    super(UserReviewCompleteBIModel.eventName, userId);
    this.#productId = productId;
    this.#shippingTime = shippingTime;
    this.#descriptionQuality = descriptionQuality;
    this.#communication = communication;
    this.#productStatus = productStatus;
    this.#packageStatus = packageStatus;
    this.#overallRating = overallRating;
    this.#comment = comment;
  }

  get productId() {
    return this.#productId;
  }

  get shippingTime() {
    return this.#shippingTime;
  }

  get descriptionQuality() {
    return this.#descriptionQuality;
  }

  get communication() {
    return this.#communication;
  }

  get productStatus() {
    return this.#productStatus;
  }

  get packageStatus() {
    return this.#packageStatus;
  }

  get overallRating() {
    return this.#overallRating;
  }

  get comment() {
    return this.#comment;
  }

  get modelData() {
    return {
      product_id: this.productId,
      shipping_time: this.shippingTime,
      description_quality: this.descriptionQuality,
      communication: this.communication,
      product_status: this.productStatus,
      package_status: this.packageStatus,
      overall_rating: this.overallRating,
      comment: this.comment
    };
  }

}
